import AbstractListenerAction from "~/ts/library/listen/AbstractListenerAction";
import {OperatorApplicationEventManager} from "~/operatorApplication/ts/OperatorApplicationEventManager";

export default class TranscribeAudioFile extends AbstractListenerAction {
    public getAction(): string {
        return "transcribeAudioFile";
    }

    public onAction(payload: CometOperatorApplication.TranscribeAudioFileCometMessageOpenApiModel): void {
        OperatorApplicationEventManager.emit(getTranscribeEventId(payload.fileId), payload.text);
    }
}

export function getTranscribeEventId(fileId: string) {
    return fileId;
}

/*
{"id":1,"channel":"14755221258159fdb93bdc95487328cc4cc83208","text":{"action":"editMessage","id":184744097,"text":"в пердакшен!"},"time":"1561049769050","tag":0}
 */